import React, { useEffect } from "react";
import "./";
// import "./responsive.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Router from "./Router";
import "./App.css"


const App = () => {


  useEffect(() => {
    AOS.init();
  }, []);

  const showmessage = async (message) => {
    try {
      var x = document.getElementById("snackbar");
      x.className = "show";
      x.innerText = message;
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {/* <Pageload /> */}
      <div id="snackbar"></div>
      <Router />
    </>
  );
};

export default App;